import { render, staticRenderFns } from "./GlobalConfigIndex.vue?vue&type=template&id=64478b58&scoped=true"
import script from "./GlobalConfigIndex.vue?vue&type=script&lang=js"
export * from "./GlobalConfigIndex.vue?vue&type=script&lang=js"
import style0 from "./GlobalConfigIndex.vue?vue&type=style&index=0&id=64478b58&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64478b58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64478b58')) {
      api.createRecord('64478b58', component.options)
    } else {
      api.reload('64478b58', component.options)
    }
    module.hot.accept("./GlobalConfigIndex.vue?vue&type=template&id=64478b58&scoped=true", function () {
      api.rerender('64478b58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cfg/GlobalConfigIndex.vue"
export default component.exports